// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"t3-z","dimensionLabel":"u3-z","styleChooserControlWrapper":"v3-z","styleChooserControl":"w3-z","disabled":"x3-z","giftCard":"y3-z","styleChooserText":"z3-z"};